<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-icon>mdi-chart-bar-stacked</v-icon><span class="headerTitle">{{ labels.riskAccumTitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 class="mt-2">
                <template>
                  <v-data-table
                    v-model="riskAccum.selected"
                    :headers="riskAccum.headers"
                    :items="riskAccum.items"
                    :loading="riskAccum.loading"
                    item-key="seqNo"
                    class="elevation-1"
                  >
                    <template v-slot:item="row">
                      <tr :active="row.selected" @click="row.selected = !row.selected">
                        <td>{{ row.item.seqNo }}</td>
                        <td>{{ row.item.blkGrp }}</td>
                        <td>{{ row.item.blkSGrp1 }}</td>
                        <td>{{ row.item.blkSGrp2 }}</td>
                        <td>{{ row.item.blk }}</td>
                        <td>{{ row.item.floatSilim }}</td>
                        <td>{{ row.item.floatPrem }}</td>
                        <td>{{ row.item.cfmRiskYN }}</td>
                        <td>{{ row.item.delRiskYN }}</td>
                        <!-- <td class="table-action-header">
                          <table-action :rowData="row" review @review="doSelectRiskBlock(row.item)" remove @remove="doPromptRemoveRiskBlock(row.item)"></table-action>
                        </td> -->
                        <td style="text-align: center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="primary" text @click.prevent="doSelectRiskBlock(row.item)">
                                <v-icon>mdi-magnify</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.query }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </template>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4>
                <v-subheader class="queryLabel">{{ labels.seqNo }}</v-subheader>
                <span class="queryValue">{{ riskForm.seqNo }}</span>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4>
                <v-subheader class="queryLabel">{{ labels.cfmRisk }}</v-subheader>
                <span class="queryValue" v-if="riskForm.cfmRisk">{{ riskForm.cfmRisk }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4>
                <v-subheader class="queryLabel">{{ labels.delRisk }}</v-subheader>
                <span class="queryValue" v-if="riskForm.delRisk">{{ riskForm.delRisk }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4> </v-flex>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{ labels.accmType }}</v-subheader>
                <span class="queryValue" v-if="riskForm.accmType">{{ riskForm.accmType }} - {{ riskForm.accmTypeDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="queryLabel" v-if="riskForm.blkGrpLblS">{{ labels.blkGrp }} - {{ riskForm.blkGrpLblS }}</v-subheader>
                <v-subheader class="queryLabel" v-else>{{ labels.blkGrp }}</v-subheader>
                <span class="queryValue" v-if="riskForm.blkGrp">{{ riskForm.blkGrp }} - {{ riskForm.blkGrpDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="queryLabel" v-if="riskForm.blkSgrp1lblS">{{ labels.blksGrp1 }} - {{ riskForm.blkSgrp1lblS }}</v-subheader>
                <v-subheader class="queryLabel" v-else>{{ labels.blksGrp1 }}</v-subheader>
                <span class="queryValue" v-if="riskForm.blksGrp1">{{ riskForm.blksGrp1 }} - {{ riskForm.blksGrp1Desc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="queryLabel" v-if="riskForm.blkSgrp2lblS">{{ labels.blksGrp2 }} - {{ riskForm.blkSgrp2lblS }}</v-subheader>
                <v-subheader class="queryLabel" v-else>{{ labels.blksGrp2 }}</v-subheader>
                <span class="queryValue" v-if="riskForm.blksGrp2">{{ riskForm.blksGrp2 }} - {{ riskForm.blksGrp2Desc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="queryLabel" v-if="riskForm.blkLblS">{{ labels.blk }} - {{ riskForm.blkLblS }}</v-subheader>
                <v-subheader class="queryLabel" v-else>{{ labels.blk }}</v-subheader>
                <span class="queryValue" v-if="riskForm.blk">{{ riskForm.blk }} - {{ riskForm.blkDesc }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4>
                <v-subheader class="queryLabel">{{ labels.floatSilim }}</v-subheader>
                <span class="queryValue" v-if="riskForm.floatSilim">{{ riskForm.floatSilim }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4>
                <v-subheader class="queryLabel">{{ labels.floatPrem }}</v-subheader>
                <span class="queryValue" v-if="riskForm.floatPrem">{{ riskForm.floatPrem }}</span>
                <span class="queryValue" v-else>-</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import { formatDisplayDateTime2 } from '@/utils/date'
import { formatYesNo } from '@/utils/boolean'

export default {
  data() {
    return {
      labels: {
        riskAccumTitle: 'Risk Accumulation',
        query: 'Query',
        seqNo: 'Sequence No.',
        cfmRisk: 'Confirm Risk',
        accmType: 'Accumulation Type',
        blkGrp: 'Block Group',
        blksGrp1: 'Block Sub Group 1',
        blksGrp2: 'Block Sub Group 2',
        blk: 'Block',
        floatSilim: 'Floating SI',
        floatPrem: 'Floating Premium',
        delRisk: 'Deleted'
      },
      riskForm: {
        seqNo: undefined,
        cfmRisk: undefined,
        accmType: undefined,
        blkGrp: undefined,
        blksGrp1: undefined,
        blksGrp2: undefined,
        blk: undefined,
        accmTypeDesc: undefined,
        blkGrpDesc: undefined,
        blksGrp1Desc: undefined,
        blksGrp2Desc: undefined,
        blkDesc: undefined,
        floatSilim: undefined,
        floatPrem: undefined,
        blkLblS: undefined,
        blkGrpLblS: undefined,
        blkSgrp1lblS: undefined,
        blkSgrp2lblS: undefined
      },
      riskAccum: {
        selected: [],
        headers: [
          { text: 'Seq.No.', value: 'seqNo' },
          { text: 'Block Group', value: 'blkGrp' },
          { text: 'Sub Group 1', value: 'blkSGrp1' },
          { text: 'Sub Group 2', value: 'blkSGrp2' },
          { text: 'Block', value: 'blk' },
          { text: 'Float SI', value: 'floatSilim' },
          { text: 'Float Prem', value: 'floatPrem' },
          { text: 'Confirm', value: 'cfmRisk' },
          { text: 'Deleted', value: 'delRisk' },
          { text: 'Actions', value: 'action', align: 'center' }
        ],
        items: [],
        loading: undefined
        // saving: undefined
      }
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    policyQuery() {
      return this.$store.state.underwriting.policyQuerySettings
    },
    policyRisk() {
      return this.$store.state.underwriting.policyQuerySettings
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('policyQueryInit')])
      this.riskForm.accmType = undefined
      this.riskForm.seqNo = undefined
      this.riskForm.blkGrp = undefined
      this.riskForm.blksGrp1 = undefined
      this.riskForm.blksGrp2 = undefined
      this.riskForm.blk = undefined
      this.riskForm.accmTypeDesc = undefined
      this.riskForm.blkGrpDesc = undefined
      this.riskForm.blksGrp1Desc = undefined
      this.riskForm.blksGrp2Desc = undefined
      this.riskForm.blkDesc = undefined
      this.riskForm.cfmRisk = undefined
      this.riskForm.delRisk = undefined
      this.riskForm.floatSilim = undefined
      this.riskForm.floatPrem = undefined
      this.riskForm.blkLblS = undefined
      this.riskForm.blkGrpLblS = undefined
      this.riskForm.blkSgrp1lblS = undefined
      this.riskForm.blkSgrp2lblS = undefined
      if (this.policyQuery.init === 1) {
        //   this.getPolCargoRisk()
        this.getRiskAccumList()
      }
    },
    // async getPolCargoRisk() {
    //   const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.riskAccumulation
    //   if (apiUrl) {
    //     try {
    //       this.loading = true
    //       const expand = {
    //         polNo: this.polMaster.polNo,
    //         renCnt: this.polMaster.renCnt,
    //         endtCnt: this.polMaster.endtCnt,
    //         riskGrpNo: this.polRisk.riskGrpNo,
    //         riskNo: this.polRisk.riskNo,
    //         seqNo: 1
    //       }
    //       const result = await this.$http.get(expandURI(apiUrl, expand))
    //       if (result.data) {
    //         this.riskForm.accmType = result.data.accmType
    //         this.riskForm.blkGrp = result.data.blkGrp
    //         this.riskForm.blksGrp1 = result.data.blksGrp1
    //         this.riskForm.blksGrp2 = result.data.blksGrp2
    //         this.riskForm.blk = result.data.blk
    //         this.riskForm.accmTypeDesc = result.data.accmTypeDesc
    //         this.riskForm.blkGrpDesc = result.data.blkGrpDesc
    //         this.riskForm.blksGrp1Desc = result.data.blksGrp1Desc
    //         this.riskForm.blksGrp2Desc = result.data.blksGrp2Desc
    //         this.riskForm.blkDesc = result.data.blkDesc
    //       }
    //       this.loading = false
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.notify('Risk Accumulation: ' + data)
    //       }
    //     }
    //   } else {
    //     this.$toast.error('The request failed because it is trying to execute an invalid API url.')
    //   }
    // },
    async getRiskAccumList() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.riskAccumList
      if (apiUrl) {
        try {
          this.riskAccum.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          this.displayRiskBlockList(result).then(() => {
            this.riskAccum.loading = false
            if (this.riskAccum.items.length > 0) {
              this.doSelectRiskBlock(this.riskAccum.items[0])
            }
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error(this.invalidAPIUrlMessage())
      }
    },
    async displayRiskBlockList(result) {
      const { data } = result
      if (data) {
        this.riskAccum.items = []
        data.data.map((polRiskBlk) => {
          const polRiskBlkList = {
            polNo: polRiskBlk.polNo,
            renCnt: polRiskBlk.renCnt,
            endtCnt: polRiskBlk.endtCnt,
            riskGrpNo: polRiskBlk.riskGrpNo,
            riskNo: polRiskBlk.riskNo,
            seqNo: polRiskBlk.seqNo,
            accmType: polRiskBlk.accmType,
            blkGrp: polRiskBlk.blkGrp,
            blkSGrp1: polRiskBlk.blkSgrp1,
            blkSGrp2: polRiskBlk.blkSgrp2,
            blk: polRiskBlk.blk,
            floatSilim: formatPrice(polRiskBlk.floatSilim),
            floatPrem: formatPrice(polRiskBlk.floatPrem),
            effDate: polRiskBlk.effDate,
            cfmRisk: polRiskBlk.cfmRisk,
            cfmRiskYN: formatYesNo(polRiskBlk.cfmRisk),
            createdName: polRiskBlk.createdName,
            modifiedName: polRiskBlk.modifiedName,
            createdBy: polRiskBlk.createdBy,
            createdDate: formatDisplayDateTime2(polRiskBlk.createdDate),
            modifiedBy: polRiskBlk.modifiedBy,
            modifiedDate: formatDisplayDateTime2(polRiskBlk.modifiedDate),
            newRec: polRiskBlk.newRec,
            blkGrpDesc: polRiskBlk.blkGrpDesc,
            blkSgrp1Desc: polRiskBlk.blkSgrp1Desc,
            blkSgrp2Desc: polRiskBlk.blkSgrp2Desc,
            blkDesc: polRiskBlk.blkDesc,
            accmTypeDesc: polRiskBlk.accumTypeDesc,
            blkLblS: polRiskBlk.blkLblS,
            blkGrpLblS: polRiskBlk.blkGrpLblS,
            blkSgrp1lblS: polRiskBlk.blkSgrp1lblS,
            blkSgrp2lblS: polRiskBlk.blkSgrp2lblS,
            delRisk: polRiskBlk.delRisk,
            delRiskYN: formatYesNo(polRiskBlk.delRisk)
          }
          this.riskAccum.items.push(polRiskBlkList)
        })
      } else {
        this.riskAccum.items = []
      }
      return true
    },
    doSelectRiskBlock(data) {
      this.riskForm.seqNo = data.seqNo
      this.riskForm.cfmRisk = data.cfmRiskYN
      this.riskForm.accmType = data.accmType
      this.riskForm.accmTypeDesc = data.accmTypeDesc
      this.riskForm.blkGrp = data.blkGrp
      this.riskForm.blkGrpDesc = data.blkGrpDesc
      this.riskForm.blksGrp1 = data.blkSGrp1
      this.riskForm.blksGrp1Desc = data.blkSgrp1Desc
      this.riskForm.blksGrp2 = data.blkSGrp2
      this.riskForm.blksGrp2Desc = data.blkSgrp2Desc
      this.riskForm.blk = data.blk
      this.riskForm.blkDesc = data.blkDesc
      this.riskForm.floatSilim = data.floatSilim
      this.riskForm.floatPrem = data.floatPrem
      this.riskForm.blkLblS = data.blkLblS
      this.riskForm.blkGrpLblS = data.blkGrpLblS
      this.riskForm.blkSgrp1lblS = data.blkSgrp1lblS
      this.riskForm.blkSgrp2lblS = data.blkSgrp2lblS
      this.riskForm.delRisk = data.delRiskYN
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
